<template>
  <Hero
      :image="getStrapiImageLocation(data?.hero?.image) || ''"
      image-provider="strapi"
      extra-content-classes="vcenter grid--two"
      :vertical-center="true"
      small
    >
    <template #left>
      <h2 class="heading--med text--white text--bold no-lh">Privacybeleid</h2>
    </template>
  </Hero>
  <div class="block maxw--inset block--y">
    <div class="text--m last-nm render-headings">
      <StrapiBlocksText :nodes="data?.content || []"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
// TODO: allow for editing
// const err = createError({ statusCode: 404, message: 'Pagina niet gevonden' });
// throw err;

const { findOne } = useStrapi();

const { data } = await useAsyncData(
  'privacyPage',
  () => findOne<Page>('privacy-policy-page', { 
    populate: [
      'hero', 'hero.rightButton', 'hero.image'
    ] 
  }),
  {
    transform: flattenObject
  }
);

if (!data.value) {
  throw createError({ statusCode: 404, message: 'Pagina niet gevonden' });
}

useHead({
  title: 'Privacybeleid',
});

useSeoMeta({
  description: data.value?.seo?.metaDescription,
  ogTitle: data.value?.seo?.metaTitle,
  ogDescription: data.value?.seo?.metaDescription,
  ogImage: getStrapiImageLocation(data.value?.seo?.metaImage, true),
  ogUrl: 'https://werkenbijvaneerd.nl/privacybeleid/',
  twitterTitle: data.value?.seo?.metaTitle,
  twitterDescription: data.value?.seo?.metaDescription,
  twitterImage: getStrapiImageLocation(data.value?.seo?.metaImage, true),
  twitterCard: 'summary_large_image',
})

</script>
